import { create } from 'zustand';
import {
  getOtpCodeAction,
  resendOtpCodeAction,
  sendOtpCodeAction
} from './action';

type AccountStoreType = {
  phoneNumber: string;
  otpRequestLoading: boolean;
  otpRequestError: boolean;
  getOtpCodeAction: (phoneNumber: string, branchId: number) => Promise<boolean>;
  sendOtpLoading: boolean;
  sendOtpError: boolean;
  sendOtpCodeAction: (
    phoneNumber: string,
    confirmationCode: string,
    uniqueId: number,
    navigate
  ) => void;
  resendOtpCodeAction: (phoneNumber: string, branchId: number) => void;
};

const useAccountStore = create<AccountStoreType>((set) => ({
  phoneNumber: '',
  otpRequestLoading: false,
  otpRequestError: false,
  sendOtpLoading: false,
  sendOtpError: false,
  getOtpCodeAction: (phoneNumber, branchId) =>
    getOtpCodeAction(set, phoneNumber, branchId),
  sendOtpCodeAction: (phoneNumber, confirmationCode, uniqueId, navigate) =>
    sendOtpCodeAction(set, phoneNumber, confirmationCode, uniqueId, navigate),
  resendOtpCodeAction: (phoneNumber, branchId) =>
    resendOtpCodeAction(set, phoneNumber, branchId)
}));

export default useAccountStore;
